import React from 'react'
import PropTypes from 'prop-types'

const DangerousInnerHTML = ({ children, component, ...rest }) => {
  const Component = component
  return <Component {...rest} dangerouslySetInnerHTML={{ __html: children }} />
}

DangerousInnerHTML.propTypes = {
  children: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

DangerousInnerHTML.defaultProps = {
  component: 'span',
}

export default DangerousInnerHTML
